import { DropdownMenu as KobalteDropdownMenu } from "@kobalte/core/dropdown-menu"
import { type ParentProps, Show } from "solid-js"
import {
  dropdownContentClass,
  dropdownItemLabelClass,
  dropdownItemRecipe,
} from "@/designSystem/components/dropdown-menu.css"
import { Icon } from "@/designSystem/components/icon"
import { useI18nContext } from "@/i18n/i18n-solid"

type EmbedMenuProps = ParentProps<{
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  triggerClass: string
  triggerLabel: string
  onTriggerPointerDown: () => void
  onTriggerClick: (event: MouseEvent) => void
  onTriggerKeyDown: (event: KeyboardEvent) => void
  onTriggerDragStart: (event: DragEvent) => void
  onTriggerDragEnd: () => void
  displayMode: string
  hasRichEmbed: boolean
  onUpdateDisplayMode: (mode: string) => void
  onDelete: () => void
}>

export function EmbedMenu(props: EmbedMenuProps) {
  const { LL } = useI18nContext()

  return (
    <KobalteDropdownMenu open={props.isOpen} onOpenChange={props.onOpenChange}>
      <KobalteDropdownMenu.Trigger
        class={props.triggerClass}
        aria-label={props.triggerLabel}
        data-block-node-menu-trigger="true"
        draggable="true"
        onPointerDown={props.onTriggerPointerDown}
        onClick={props.onTriggerClick}
        onKeyDown={props.onTriggerKeyDown}
        onDragStart={props.onTriggerDragStart}
        onDragEnd={props.onTriggerDragEnd}
      >
        {props.children}
      </KobalteDropdownMenu.Trigger>
      <KobalteDropdownMenu.Portal>
        <KobalteDropdownMenu.Content class={dropdownContentClass}>
          <Show when={props.hasRichEmbed}>
            <KobalteDropdownMenu.Sub>
              <KobalteDropdownMenu.SubTrigger
                class={dropdownItemRecipe({ hue: "sand" })}
              >
                <Icon name="globe" size="18" />
                <span class={dropdownItemLabelClass}>
                  {LL().editor.embedDisplay()}
                </span>
                <Icon name="chevron-right" size="18" />
              </KobalteDropdownMenu.SubTrigger>
              <KobalteDropdownMenu.Portal>
                <KobalteDropdownMenu.SubContent class={dropdownContentClass}>
                  <KobalteDropdownMenu.Item
                    class={dropdownItemRecipe({ hue: "sand" })}
                    onSelect={() => props.onUpdateDisplayMode("interactive")}
                  >
                    <Icon
                      name={props.displayMode !== "card" ? "check" : "globe"}
                      size="18"
                    />
                    <span class={dropdownItemLabelClass}>
                      {LL().editor.embedDisplayEmbed()}
                    </span>
                  </KobalteDropdownMenu.Item>
                  <KobalteDropdownMenu.Item
                    class={dropdownItemRecipe({ hue: "sand" })}
                    onSelect={() => props.onUpdateDisplayMode("card")}
                  >
                    <Icon
                      name={
                        props.displayMode === "card" ? "check" : "newspaper"
                      }
                      size="18"
                    />
                    <span class={dropdownItemLabelClass}>
                      {LL().editor.embedDisplayCard()}
                    </span>
                  </KobalteDropdownMenu.Item>
                </KobalteDropdownMenu.SubContent>
              </KobalteDropdownMenu.Portal>
            </KobalteDropdownMenu.Sub>
          </Show>
          <KobalteDropdownMenu.Item
            class={dropdownItemRecipe({ hue: "rose" })}
            onSelect={props.onDelete}
          >
            <Icon name="trash-2" size="18" />
            <span class={dropdownItemLabelClass}>{LL().common.delete()}</span>
          </KobalteDropdownMenu.Item>
        </KobalteDropdownMenu.Content>
      </KobalteDropdownMenu.Portal>
    </KobalteDropdownMenu>
  )
}
